import React, { useState } from "react";
import api from "../utils/api";
import { toast } from "sonner";

const TestimonialPopup = ({ feature = "Ask Universe" }) => {
  const [message, setMessage] = useState("");
  const [rating, setRating] = useState(5);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const submitTestimonial = async () => {
    if (message.trim().length < 10) {
      toast.error("Please write at least 10 characters.");
      return;
    }

    try {
      setLoading(true);

      await api.post("/testimonials", {
        message: message.trim(),
        rating,
        feature,
        language: "en",
      });

      setSubmitted(true);
      toast.success("Thank you! Your experience was submitted.");
    } catch (error) {
      console.error("Testimonial submit error:", error);
      toast.error("Could not submit testimonial. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="relative z-[9999] pointer-events-auto w-full max-w-lg p-6 rounded-3xl bg-purple-900/30 border border-purple-500/30 text-white text-center">
        Thank you for sharing your experience ✨
      </div>
    );
  }

  return (
    <div className="relative z-[9999] pointer-events-auto w-full max-w-lg p-6 rounded-3xl bg-black/40 border border-white/10 backdrop-blur-xl text-white">
      <h2 className="text-2xl font-bold mb-2">
        Did this resonate with you?
      </h2>

      <p className="text-white/60 mb-4">
        Share your experience with the Universe community.
      </p>

      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Write your experience..."
        className="relative z-[9999] pointer-events-auto w-full h-32 p-4 rounded-2xl bg-white/10 border border-white/10 text-white outline-none focus:border-purple-400"
      />

      <div className="relative z-[9999] pointer-events-auto flex gap-2 mt-4">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            type="button"
            key={star}
            onClick={() => setRating(star)}
            className={`relative z-[9999] pointer-events-auto text-3xl ${
              rating >= star ? "text-yellow-400" : "text-white/30"
            }`}
          >
            ★
          </button>
        ))}
      </div>

      <button
        type="button"
        onClick={submitTestimonial}
        disabled={loading}
        className="relative z-[9999] pointer-events-auto mt-5 px-6 py-3 rounded-2xl bg-gradient-to-r from-purple-500 to-pink-500 text-white disabled:opacity-50"
      >
        {loading ? "Sending..." : "Share Experience"}
      </button>
    </div>
  );
};

export default TestimonialPopup;
